module.exports = __webpack_public_path__ + "img/6_wind.d78a821f.jpg";